import { downloadPortfolioBundle } from '@actions/assurance';
import { AnalyticsEvents } from '@services/analytics/AnalyticsEvents';
import { getAnalytics } from '@services/analytics/AnalyticsService';

export const portfolioBundleDownload = (_id: string, portfolioInitiativeId: string) => {
  return downloadPortfolioBundle(_id).then(async ([document]) => {
    if (!document || !document.url) {
      return;
    }

    window.open(document.url, '_blank', '');

    const analytics = getAnalytics();
    return analytics.track(AnalyticsEvents.SurveyDataDownloaded, {
      assurancePortfolioId: _id,
      initiativeId: portfolioInitiativeId,
      source: 'survey_assurance',
    });
  });
};
